import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { IGetRegionResponseSchema } from '../../../repositories/monolith-python/entities/schemas/GetRegionResponseSchema';
import { fetchGetRegion, TGetRegionResponse } from '../../../repositories/monolith-python/v1/get-region';
import { IRegion } from '../../../types/geoSwitcher';
import { TThunkAction } from '../../../types/redux';
import { getRegionFailed } from './getRegionFailed';
import { getRegionLoading } from './getRegionLoading';
import { getRegionSucceed } from './getRegionSucceed';
import { buildRedirectUrl } from './utils';

function prepareRegion(region: IGetRegionResponseSchema): IRegion {
  return {
    id: region.id,
    displayName: region.displayName,
    mainTownId: region.mainTownId || null,
    baseHost: region.baseHost || null,
  };
}

export const getRegion = (regionId: number): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const {
      httpApi,
      logger,
      custom: { subdomain },
    } = context;

    dispatch(getRegionLoading());
    try {
      const response: TGetRegionResponse = await fetchGetRegion({
        httpApi,
        parameters: {
          regionId,
        },
        config: { subdomain },
      });

      if (response.statusCode !== 200) {
        throw new HttpBadStatusCodeError('Не удалось загрузить регион', response.statusCode, 'actions.getRegion');
      }

      const region = prepareRegion(response.response.data);

      dispatch(getRegionSucceed(region));
      if (region.baseHost && region.baseHost !== location.origin) {
        location.href = buildRedirectUrl(region.baseHost);
      }
    } catch (ex) {
      logger.error(ex, {
        domain: 'actions.getRegion',
      });

      dispatch(getRegionFailed());
    }
  };
};
